import {LoadingButton} from '@mui/lab';
import {Box} from '@mui/material';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {ExportField} from '../../interfaces/Export';
import {saveFile} from '../../utils/file';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import ExportFieldForm from '../common/ExportFieldForm';
import ModalFixed from '../common/ModalFixed';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props {
  value?: {
    exportFields?: ExportField[];
    params?: {
      date_start?: string;
      date_end?: string;
      page?: number;
      limit?: number;
      order?: string;
      dir?: 'ASC' | 'DESC';
      status?: 'active' | 'inactive' | 'unacknowledged' | 'all';
    };
    sensorId?: string;
    emoduleId?: string;
  };
}

const AMSShortTermHistoryExportExcel = ({value}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);

  const [isOpened, setIsOpened] = useState(false);

  const checkFields = () => {
    setIsOpened(true);
  };

  const fetchData = async (fields: string[]) => {
    setIsOpened(false);
    setIsFetching(true);
    try {
      const params = {
        ...value?.params,
        export: 'excel',
        fields,
      };
      const resp = await API.get(
        `${apiBaseUrl}/ams/${value?.sensorId}/${value?.emoduleId}/short-term-history`,
        {
          params,
          responseType: 'blob',
        }
      );
      const dateStart = value?.params?.date_start ?? dayjs().format('YYYY-MM-DD');
      const dateEnd = value?.params?.date_end ?? dayjs().format('YYYY-MM-DD');
      saveFile(resp.data, `ams_short_term_history_${dateStart}_${dateEnd}.xlsx`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_ams_st_export');
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          loading={isFetching}
          onClick={() => checkFields()}
        >
          Export to Excel
        </LoadingButton>
      </Box>
      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <ExportFieldForm
                exportFields={value?.exportFields}
                loading={isFetching}
                onChange={fetchData}
                close={() => setIsOpened(false)}
              />
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default AMSShortTermHistoryExportExcel;
